import ReactLoadingOriginal from 'react-loading';
import React from 'react';

const ReactLoading = () => (
  <ReactLoadingOriginal type="cylon" color="#ff9c34" />
);

export default ReactLoading;
